import _ from 'lodash';
import { FieldNames } from '@/constants/FieldNames';
import { SourceDataInitials } from '@/constants/SourceDataInitials';
import SymbolDetailsUtil from '@/models/common/SymbolDetailsUtil.';
import IComp from '@/models/Comp';
import CompAddressUtils from '@/models/comp/CompAddressUtils';
import SourceDataUtils from '@/models/comp/SourceDataUtils';
import IFactSheet from '@/models/fact-sheet/IFactSheet';
import MlsPropertyItemUtils from '@/models/mls/MlsPropertyItemUtils';
import IMLSPropertyItem from '@/models/mls/IMLSPropertyItem';
import IFactSheetProperty, { IBaseFactSheet, newFactSheetProperty } from '@/models/fact-sheet/IFactSheetProperty';
import ImageUtils from '@/utils/ImageUtils';
import utils from '@/utils/QSUtils';

export default {
    /**
     * Converts the given comp and optional MLS property item into a fact sheet.
     * Does not include the sales history, add it separately.
     * @see FactSheetManager
     *
     * @param comp
     * @param mlsPropertyItem
     * @returns
     */
    convert(comp: IComp, mlsPropertyItem: IMLSPropertyItem | null): IFactSheet {
        const address1AndUnitNo = CompAddressUtils.combineAddress1AndUnitNo(comp.address);
        const factSheetProperty: IFactSheetProperty = newFactSheetProperty();
        const factSheet: IFactSheet = {};
        factSheet[address1AndUnitNo] = factSheetProperty;

        if (comp.sourceData) {
            const transferItems = factSheetProperty.transfer;

            for (const compData of comp.sourceData) {
                // Prevent replacement of existing in case of duplicates
                if (!utils.isKeyInObject(transferItems, compData.fieldName)) {
                    // if photo is from SE, replace link with b64
                    if (compData.fieldName === FieldNames.CompPhoto && compData.value !== null && compData.value.includes('https://')) {
                        ImageUtils.convertToBase64(compData.value, function (b64img: string) {
                            compData.value = b64img;
                        });
                    }

                    transferItems[compData.fieldName] = compData.value;
                }
            }
        }

        if (comp.sourceDataDB) {
            const symbolDetails = SymbolDetailsUtil.getBySymbol(SourceDataInitials.Database);
            const duplicateSourceData = SourceDataUtils.duplicate(comp.sourceDataDB.sourceData);
            factSheetProperty[symbolDetails.name as keyof IBaseFactSheet] = duplicateSourceData;
        }

        if (comp.sourceDataPR) {
            const symbolDetails = SymbolDetailsUtil.getBySymbol(SourceDataInitials.PublicRecords);
            const duplicateSourceData = SourceDataUtils.duplicate(comp.sourceDataPR.sourceData);
            factSheetProperty[symbolDetails.name as keyof IBaseFactSheet] = duplicateSourceData;
        }

        if (comp.sourceDataSE) {
            const symbolDetails = SymbolDetailsUtil.getBySymbol(SourceDataInitials.SmartExchange);
            const duplicateSourceData = SourceDataUtils.duplicate(comp.sourceDataSE.sourceData);
            factSheetProperty[symbolDetails.name as keyof IBaseFactSheet] = duplicateSourceData;
        }

        if (comp.sourceDataMLS) {
            const symbolDetails = SymbolDetailsUtil.getBySymbol(SourceDataInitials.Mls);
            const duplicateSourceData = SourceDataUtils.duplicate(comp.sourceDataMLS.sourceData);

            // When MLS we want to add any "_dataFactSheet" values
            if (mlsPropertyItem) {
                const factSheetSourceDatas = MlsPropertyItemUtils.getFactSheetDatas(mlsPropertyItem);
                Object.assign(duplicateSourceData, factSheetSourceDatas);
            }

            factSheetProperty[symbolDetails.name as keyof IBaseFactSheet] = duplicateSourceData;
        }

        return factSheet;
    },
};
